import { render, staticRenderFns } from "./BroadcastProgramInfo.vue?vue&type=template&id=167db165"
import script from "./BroadcastProgramInfo.vue?vue&type=script&lang=js"
export * from "./BroadcastProgramInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports